import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as space from '../../space'

/**
 * Logs each time a space record loses its occupier through an edit: the
 * occupier changed to a non-occupier or replaced by another organization.
 * Deleting an organization assignment deletes that organization's rows too,
 * since a deleted assignment is treated as one that was never made
 */
export const RESOURCE = {
  payload: {
    description:
      'Each organization a space record previously had as its occupier, with when it lost it and by whom',
    dimension: space.RESOURCE.payload,
    name: 'Space Previous Occupier',
    partialId: PartialId.Standard.create('space_previous_occupier'),
  },
  type: core.quiver.Resource.Type.DmsSnapshot,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsSnapshot>

export const MODEL_ID = core.dms.models.Snapshot.Id.from({
  context: core.dms.models.Snapshot.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
